<template functional>
    <b-card-body class="text-center">
        <b-spinner small/>
    </b-card-body>
</template>
<script>
    export default {
        name: 'Spinner'
    }
</script>
